/**
 * AiRecordSchemaService
 * Service for managing AI record schema definitions
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for AI record schema CRUD operations with target type lookup
 */
export class AiRecordSchemaService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AiRecordSchemaService.DEFAULT_SERVICE_PATH,
            basePath: AiRecordSchemaService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY TARGET TYPE ====================
    /**
     * Get record schema by target record type
     * @param targetRecordType - The target record type identifier
     * @returns The record schema for the target type
     * @throws Error if not found
     */
    async getByTargetType(targetRecordType) {
        const response = await this.getByTargetTypeRaw(targetRecordType);
        if (!response.data) {
            throw new Error(`Record schema for target type ${targetRecordType} not found`);
        }
        return response.data;
    }
    /**
     * Get record schema by target record type with full response
     * @param targetRecordType - The target record type identifier
     * @returns ResponseData with the record schema
     */
    getByTargetTypeRaw(targetRecordType) {
        const url = this.buildUrl(`type/${targetRecordType}`);
        return this.http.get(url);
    }
}
AiRecordSchemaService.DEFAULT_SERVICE_PATH = 'ai-management';
AiRecordSchemaService.BASE_PATH = 'api/ai/record-schemas';
//# sourceMappingURL=AiRecordSchemaService.js.map